import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import React, { useCallback, useState } from 'react';
import { Link } from 'react-router-dom';
import { HashLoader } from 'react-spinners';
import AlertMessage from '../common/AlertMessage/AlertMessage';

import BrandLogo from '../../branding/BrandLogo';
import { forgotPasswordApiCall } from '../../services/api/users';
import { APP_ROUTES } from '../../utils/constants/appRoutes';
import { validateEmail } from '../../utils/helpers/helpers';
import LegalLinks from '../legal/LegalLinks';
import './style.css';

interface ApiResponse {
  data: {
    success: boolean;
    message?: string;
  };
}

const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const [alert, setAlert] = useState<{ show: boolean; type: 'success' | 'error'; message: string }>(
    {
      show: false,
      type: 'success',
      message: '',
    }
  );

  const handleEmailChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
  }, []);

  const handleSubmit = useCallback(async () => {
    setLoading(true);
    try {
      const response = (await forgotPasswordApiCall(email)) as ApiResponse;
      if (response.data.success) {
        setAlert({
          show: true,
          type: 'success',
          message: 'A password reset link has been sent to your email.',
        });
        setEmail('');
      } else {
        setAlert({
          show: true,
          type: 'error',
          message: 'Something went wrong, please try again later.',
        });
      }
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message || 'Something went wrong, please try again later.';

      setAlert({ show: true, type: 'error', message: errorMessage });
    } finally {
      setLoading(false);
    }
  }, [email]);

  return (
    <div className="limiter">
      <AlertMessage
        show={alert.show}
        type={alert.type}
        message={alert.message}
        onClose={() => setAlert({ ...alert, show: false })}
      />
      <div className="container-login100">
        <div className="wrap-login100">
          <div>
            <BrandLogo />
            <h5 className="Center Margin mb-4">Forgot Password?</h5>
            <div className="login-fields-container">
              <TextField
                id="outlined-email-input"
                label="Email Address"
                type="email"
                value={email}
                onChange={handleEmailChange}
                className="login-fields"
                disabled={loading}
              />
            </div>
            <Button
              size="medium"
              type="submit"
              variant="contained"
              className="full-width"
              disabled={!validateEmail(email) || loading}
              onClick={handleSubmit}
            >
              {loading ? (
                <HashLoader size={30} color="#1b6bae" speedMultiplier={0.8} />
              ) : (
                'Reset Password'
              )}
            </Button>
            <div className="mt-2 auth-nav-link">
              <Link to={APP_ROUTES.AUTH}>Return to Sign In</Link>
            </div>
            <div className="mt-2">
              <LegalLinks shortLabels />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
